var HALF_PI = Math.PI / 2;

// Constructor
function Panoramic(app, renderer, jsonFile) {
  this.app = app;
  this.renderer = renderer;

  this.preloaded = false;

  this.jsonFile = jsonFile;
  this.data = false;

  this.lon = 540;
  this.lat = 0;
  this.phi = 0;
  this.theta = 0;
  this.currentSphere = 0;

  this.isUserInteracting = false;
  this.currentHoverElement = false;
  this.mouse = {
    x: 0,
    y: 0,
  };
  this.dragStartPos = {
    x: 0,
    y: 0,
    lon: 0,
    lat: 0,
  }

  this.renderEnabled = false;

  this.preventClick = false;

  this.textureLoader = new THREE.TextureLoader();
  this.labelsMeshes = [];
  this.labelsMeshesMainOpacity = 1.0;
  this.specialMeshes = {};
  this.spheres = [];

  this.scene = new THREE.Scene();
  this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 10000);
  this.camera.target = new THREE.Vector3(0, 0, 0);
  this.camera.position.z = 0;
  this.shader1 = false;
  this.shaderVertexSprite = false;

  this.sphereResetTimeout = false;

  this.labelsFadeDuration = 1.0;

  // Call to init() is made by parent.
}

Panoramic.prototype.buildScene = function (callback) {

  var texturesLoaded = 0;
  var texturesToLoad = 0;

  this.labelsGroup = new THREE.Group();
  this.scene.add(this.labelsGroup);

  // Spheres for panoramic view
  $.each(this.data.spheres, $.proxy(function (i, sphereData) {
    this.spheres.push(false);
    texturesToLoad++
    this.textureLoader.load(
      this.data.spheres[i].map,
      $.proxy(function (texture) {
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
        var geometry = new THREE.SphereBufferGeometry(1500, 60, 40);
        geometry.scale(-1, 1, 1); // invert the geometry on the x-axis so that all of the faces point inward
        var material = new THREE.MeshBasicMaterial({map: texture});
        var sphere = new THREE.Mesh(geometry, material);
        sphere.material.opacity = (i == 0) ? 1 : 0;
        sphere.visible = (i == 0) ? true : false;
        sphere.renderOrder = (i == 0) ? 1 : 0;
        sphere.material.map.offset.x = sphereData.offset_x;
        sphere.material.map.offset.y = sphereData.offset_y;
        this.spheres[i] = sphere;
        this.scene.add(sphere);

        texturesLoaded++;
        this.app.preloader.update(texturesLoaded / texturesToLoad);
        if (texturesLoaded == texturesToLoad) {
          callback();
        }

      }, this)
    );
  }, this))

  // Labels
  $.each(this.data.points, $.proxy(function (i, point) {

    // Init material
    var material = new THREE.ShaderMaterial({
      uniforms: {
        time: {value: 0.0},
        resolution: {value: new THREE.Vector2(1, 1)},
        tTexture1: {value: false},
        tTexture2: {value: false},
        overFactor: {value: 0.0},
        color: {value: new THREE.Vector4(1, 1, 1, 1)},
        alpha: {value: 1.0},
      },
      vertexShader: this.shaderVertexSprite,
      fragmentShader: this.shader1,
      transparent: true,
      depthWrite: false,
      opacity: 1.0,
    });

    texturesToLoad++;
    this.textureLoader.load(
      point["label_texture"][window.language],
      $.proxy(function (texture) {
        var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height, 100, 100);
        material.uniforms.tTexture1.value = texture;
        // var material = new THREE.MeshBasicMaterial({alphaMap: texture, transparent: true, color: 0xFFFFFF});
        var labelMesh = new THREE.Mesh(geometry, material);
        // var material = new THREE.SpriteMaterial( { map: texture, color: 0xffffff } );
        // var labelMesh = new THREE.Sprite(material);
        labelMesh.name = point.name;
        labelMesh.data = point;
        labelMesh.position.set(Math.cos(THREE.Math.degToRad(point.lon)) * 800, Math.sin(THREE.Math.degToRad(point.lat)) * 800, Math.sin(THREE.Math.degToRad(point.lon)) * 800)
        labelMesh.scale.set(point.scale, point.scale, point.scale);
        labelMesh.lookAt(0, labelMesh.position.y, 0)
        labelMesh.renderOrder = 10;
        labelMesh.visible = (point.visible_for_spheres.indexOf(0) !== -1);
        labelMesh.data = point;
        this.labelsGroup.add(labelMesh);
        this.labelsMeshes.push(labelMesh);

        texturesLoaded++;
        this.app.preloader.update(texturesLoaded / texturesToLoad);
        if (texturesLoaded == texturesToLoad) {
          callback();
        }

      }, this)
    );

    texturesToLoad++;
    this.textureLoader.load(
      point["label_texture_over"][window.language],
      $.proxy(function (texture) {
        material.uniforms.tTexture2.value = texture;

        texturesLoaded++;
        this.app.preloader.update(texturesLoaded / texturesToLoad);
        if (texturesLoaded == texturesToLoad) {
          callback();
        }

      }, this)
    );

  }, this))

  // Update camera FOV
  this.camera.fov = this.data.spheres[0].fov;
  this.camera.updateProjectionMatrix();

  // Create sink hole special mesh
  // var geometry = new THREE.Geometry();
  // for (var j = 0; j < 1.0; j += 0.01) {
  //   // var p = Math.sin(j * Math.PI / 2);
  //   // var p = Math.sin(Math.sin(j * Math.PI/2)* Math.PI/2);
  //   var p = j;
  //   var angle = 1.9;
  //   var x = Math.cos(angle) * (p) * 1500;
  //   var y = Math.sin(angle) * (p) * 1500;
  //   var pioffset = 0.4;
  //   var v = new THREE.Vector3(x - 10, (Math.cos((j * (1 + pioffset) - pioffset) * (Math.PI / 2 + pioffset)) - 1) * 200 + 30, y);
  //   geometry.vertices.push(v);
  // }
  // var line = new MeshLine();
  // line.setGeometry(geometry);
  // var material = new MeshLineMaterial({
  //   color: 0xffffff,
  //   lineWidth: 2,
  //   opacity: 1.0,
  //   transparent: true,
  //   side: THREE.DoubleSide
  // });
  // var mesh = new THREE.Mesh(line.geometry, material);
  // mesh.renderOrder = 10;
  // this.scene.add(mesh);
  // this.specialMeshes.sinkholeLine = mesh;
}


// Load JSON and init game
Panoramic.prototype.loadShaders = function () {

  return new Promise($.proxy(function (resolve, reject) {

    var shaderLoader1 = $.ajax({
      url: "shaders/panoOverShader.glsl",
      cache: false,
      beforeSend: function (xhr) {
        xhr.overrideMimeType("text/plain; charset=utf-8");
      }
    }).done($.proxy(function (data) {
      this.shader1 = data;
    }, this)).fail(function () {
      alert("Shader file not found. Please add the data file and restart the app.");
    });

    var shaderLoader2 = $.ajax({
      url: "shaders/vertex.glsl",
      cache: false,
      beforeSend: function (xhr) {
        xhr.overrideMimeType("text/plain; charset=utf-8");
      }
    }).done($.proxy(function (data) {
      this.shaderVertexSprite = data;
    }, this)).fail(function () {
      alert("Shader file not found. Please add the data file and restart the app.");
    });

    // Wait for all
    Promise.all([
      shaderLoader1.promise(),
      shaderLoader2.promise(),
    ]).then($.proxy(function () {
      resolve()
    }, this)).catch($.proxy(function () {
      reject()
    }, this));

  }, this));

};

Panoramic.prototype.preload = function (resolve, reject) {
  if (this.preloaded) {
    console.log("Panoramic already preloaded.")
    resolve();
    return;
  }

  $.getJSON(this.jsonFile + "?v=" + OUAS_VERSION,).done($.proxy(function (data) {
    this.data = data;

    this.raycaster = new THREE.Raycaster();

    // preload and build things
    this.loadShaders().then($.proxy(function () {
      this.buildScene($.proxy(function () {

        // Resolve Promise
        console.log("Panoramic init completed.")

        this.preloaded = true;

        // Force render 1 frame to prevent jittering
        this.renderer.render(this.scene, this.camera);

        resolve();

      }, this));
    }, this));

  }, this)).fail(function () {
    console.error("Could'not load data.");
    reject();
  });
}

Panoramic.prototype.beforePreloaderFadeIn = function () {
  console.log("Panoramic: Before preloader fadein");
  this.stop();
}

Panoramic.prototype.afterPreloaderFadeIn = function () {
  console.log("Panoramic: After preloader fadein");
  this.disableRendering();
}

Panoramic.prototype.beforePreloaderFadeOut = function () {
  console.log("Panoramic: Before preloader fadeout");
  this.enableRendering();

  this.reset();
}

Panoramic.prototype.afterPreloaderFadeOut = function () {
  console.log("Panoramic: After preloader fadeout");

  this.start();
}

Panoramic.prototype.start = function () {
  this.started = true;
  $("body").addClass("game-shown");
  this.enableDrag();

  this.app.audio.fadeOutAllTracks();
  this.app.audio.play(this.data.audio, true);

  $("#panoramic-close").addClass("active").on("click", $.proxy(function (e) {
    e.preventDefault();
    this.app.gotoScenario();
  }, this));
}

Panoramic.prototype.stop = function () {
  this.started = false;
  this.disableDrag();

  $("#panoramic-close").removeClass("active").off("click");

  if (this.sphereResetTimeout != false) {
    clearTimeout(this.sphereResetTimeout);
    this.sphereResetTimeout = false
  }
}

Panoramic.prototype.enableDrag = function () {
  // $(this.renderer.domElement).off("click").on('click', $.proxy(this.onPointerClick, this));
  $(this.renderer.domElement).off("mousedown").on('mousedown', $.proxy(this.onPointerStart, this));
  $(this.renderer.domElement).off("mousemove").on('mousemove', $.proxy(this.onPointerMove, this));
  $(this.renderer.domElement).off("mouseup").on('mouseup', $.proxy(this.onPointerUp, this));
  $(this.renderer.domElement).off("contextmenu").on('contextmenu', $.proxy(this.onPointerUp, this));
  // $(this.renderer.domElement).off("wheel").on('wheel', $.proxy(this.onDocumentMouseWheel, this));
  $(this.renderer.domElement).off("touchstart").on('touchstart', $.proxy(this.onPointerStart, this));
  $(this.renderer.domElement).off("touchmove").on('touchmove', $.proxy(this.onPointerMove, this));
  $(this.renderer.domElement).off("touchend").on('touchend', $.proxy(this.onPointerUp, this));
}

Panoramic.prototype.disableDrag = function () {
  $(this.renderer.domElement).off("mousedown");
  $(this.renderer.domElement).off("mousemove");
  $(this.renderer.domElement).off("mouseup");
  // $(this.renderer.domElement).off("wheel");
  $(this.renderer.domElement).off("touchstart");
  $(this.renderer.domElement).off("touchmove");
  $(this.renderer.domElement).off("touchend");
}

Panoramic.prototype.onPointerStart = function (event) {
  this.preventClick = false;

  this.isUserInteracting = true;

  var clientX = event.clientX || event.touches[0].clientX;
  var clientY = event.clientY || event.touches[0].clientY;

  this.dragStartPos.x = clientX;
  this.dragStartPos.y = clientY;

  this.dragStartPos.lon = this.lon;
  this.dragStartPos.lat = this.lat;
}

Panoramic.prototype.onPointerMove = function (event) {
  var clientX = event.clientX || event.touches[0].clientX;
  var clientY = event.clientY || event.touches[0].clientY;

  // Prevent click the user dragged because it would dispatch a false click
  if (dist(this.dragStartPos.x, this.dragStartPos.y, clientX, clientY) > 20) {
    this.preventClick = true;
  }

  // Always save mouse x/y for hover handling
  this.mouse.x = (clientX / window.innerWidth) * 2 - 1;
  this.mouse.y = -(clientY / window.innerHeight) * 2 + 1;

  // Update panoramic position
  if (this.isUserInteracting === true) {
    this.lon = (this.dragStartPos.x - clientX) * 0.1 + this.dragStartPos.lon;
    this.lat = (clientY - this.dragStartPos.y) * 0.1 + this.dragStartPos.lat;

  }
}

Panoramic.prototype.onPointerUp = function () {
  this.isUserInteracting = false;

  // Click is prevented if the user dragged because it would dispatch a false click
  if (!this.preventClick) {
    this.detectClick();
  }

  this.preventClick = false;
}

Panoramic.prototype.resize = function () {
  this.camera.aspect = window.innerWidth / window.innerHeight;
  this.camera.updateProjectionMatrix();
}

Panoramic.prototype.animate = function () {
  if (!this.renderEnabled) {
    return;
  }
  // console.log("here")

  requestAnimationFrame($.proxy(this.animate, this));

  // Auto rotate
  // if (this.isUserInteracting === false) {
  // 	this.lon -= 0.1;
  // }

  // Do not allow negativ numbers
  if (this.lon <= 0) {
    this.lon = 360 - (this.lon % 360)
  }

  // Update position variables
  this.lat = Math.max(-85, Math.min(85, this.lat));
  this.phi = THREE.Math.degToRad(90 - this.lat);
  this.theta = THREE.Math.degToRad(this.lon);

  // Update camera position
  this.camera.target.x = 500 * Math.sin(this.phi) * Math.cos(this.theta);
  this.camera.target.y = 500 * Math.cos(this.phi);
  this.camera.target.z = 500 * Math.sin(this.phi) * Math.sin(this.theta);
  this.camera.lookAt(this.camera.target);
  this.camera.updateMatrixWorld();

  // Update label visibility
  for (var i = 0; i < this.labelsMeshes.length; i++) {
    if (this.labelsMeshes[i].visible) {
      var x1 = Math.cos(THREE.Math.degToRad(this.labelsMeshes[i].data.lon))
      var y1 = Math.sin(THREE.Math.degToRad(this.labelsMeshes[i].data.lon))
      var x2 = Math.cos(this.theta)
      var y2 = Math.sin(this.theta)
      var a = x1 - x2;
      var b = y1 - y2;
      var dist = Math.sqrt(a * a + b * b);
      // second parameter is at which angle label stats to show, third at which angle is fully shown
      var opacity = constrain(map(dist, 0.7, 0.35, 0, 1), 0, 1);
      this.labelsMeshes[i].material.opacity = opacity;
      // Copy material property into uniform value
      this.labelsMeshes[i].material.uniforms.alpha.value = this.labelsMeshes[i].material.opacity * this.labelsMeshesMainOpacity;

      // Offset rotation
      // this.labelsMeshes[i].lookAt(0, this.labelsMeshes[i].position.y, 0)
      // this.labelsMeshes[i].rotateX((-this.phi + HALF_PI));

      // special_mesh
      if (typeof this.labelsMeshes[i].data.special_mesh != "undefined") {
        var meshName = this.labelsMeshes[i].data.special_mesh;
        this.specialMeshes[meshName].material.opacity = opacity;
      }
    }

  }

  // detect labels mouse over
  this.detectHovers();

  // Render
  this.renderer.render(this.scene, this.camera);
}

Panoramic.prototype.detectHovers = function () {

  // Try to intersect with ray to detecth hover
  this.raycaster.setFromCamera(this.mouse, this.camera);
  var intersects = this.raycaster.intersectObjects(this.labelsGroup.children);

  if (intersects.length > 0) {
    var dataObject = $(this.data.points).filterByProperty("name", intersects[0].object.name)[0];
    if (typeof dataObject.actions != "undefined") {
      $("#canvas-wrapper").removeClass("cursor-default").addClass("cursor-pointer");

      // Handle elements that are under cursor
      if (this.currentHoverElement != intersects[0].object) {
        if (this.currentHoverElement) {
          this.currentHoverElement.overTween.kill();
          this.currentHoverElement.overTween = TweenMax.to(this.currentHoverElement.material.uniforms.overFactor, 0.5, {value: 0.0});

        }
        this.currentHoverElement = intersects[0].object;
        this.currentHoverElement.overTween = TweenMax.to(this.currentHoverElement.material.uniforms.overFactor, 0.5, {value: 1.0});
      }
    }
  } else {
    $("#canvas-wrapper").removeClass("cursor-pointer");

    // Restore color
    if (this.currentHoverElement) {
      this.currentHoverElement.overTween.kill();
      this.currentHoverElement.overTween = TweenMax.to(this.currentHoverElement.material.uniforms.overFactor, 0.5, {value: 0.0});
    }
    this.currentHoverElement = null;
  }

}

Panoramic.prototype.detectClick = function () {
  this.raycaster.setFromCamera(this.mouse, this.camera);
  var intersects = this.raycaster.intersectObjects(this.labelsGroup.children);
  if (intersects.length > 0) {
    var dataObject = $(this.data.points).filterByProperty("name", intersects[0].object.name)[0];
    console.log("Intersected with", dataObject);

    // Trigger action
    if (typeof dataObject.actions != "undefined") {
      $.each(dataObject.actions, $.proxy(function (i, action) {

        console.log(action)

        if (action.type == "video") {
          // Load youtube player
          this.app.videoplayer.loadVideo(action.video_id[window.language]);
        } else if (action.type == "audio") {
          // TODO play audio file
          // this.app.videoplayer.loadVideo(action.video_id);
          this.app.audio.play(action.file, true);
        } else if (action.type == "external_link") {
          // Open external link
          var url = action.url[window.language];
          window.open(url, '_blank');
        } else if (action.type == "custom") {
          // Call custom function
          console.log('calling', action.function)
          this[action.function].apply(this, action.args);
        }

      }, this));
    }
  }
}

Panoramic.prototype.switchToNextSphere = function () {
  this.gotoSphere((this.currentSphere + 1) % this.spheres.length);
}

Panoramic.prototype.gotoPano = function (panoId) {
  this.app.gotoPano(panoId)
}

Panoramic.prototype.gotoSphere = function (index, fadeDuration) {

  // fadeDuration is in seconds
  fadeDuration = typeof fadeDuration !== "undefined" ? fadeDuration : 1.0;

  var easing = Linear.easeNone;

  // Update current sphere index
  this.currentSphere = index;

  // Destroy current timeline
  if (this.switchSphereTimeline) {
    this.switchSphereTimeline.kill();
    this.switchSphereTimeline = false;
  }

  // Init new timeline
  this.switchSphereTimeline = new TimelineMax();

  // Fade out labels meshes
  // this.switchSphereTimeline.to(this, this.labelsFadeDuration, {labelsMeshesMainOpacity: 0, ease: easing}, 0);
  this.switchSphereTimeline.set(this, {labelsMeshesMainOpacity: 0, ease: easing}, 0);

  // Go through spheres to create timeline
  for (var i = 0; i < this.spheres.length; i++) {

    if (i == this.currentSphere) {
      // Show sphere
      this.spheres[i].visible = true;
      this.switchSphereTimeline.to(this.spheres[i].material, fadeDuration, {
        opacity: 1.0,
        ease: easing,
        callbackScope: this,
        onStart: function (i) {
          this.spheres[i].material.transparent = true;
          this.spheres[i].renderOrder = 1;
        },
        onStartParams: [i],
        onComplete: function (i) {
          this.spheres[i].material.transparent = false;
        },
        onCompleteParams: [i]
      }, 0);

    } else if (this.spheres[i].material.opacity != 0) {

      // Hide sphere
      this.switchSphereTimeline.to(this.spheres[i].material, fadeDuration, {
        opacity: 0.0,
        ease: easing,
        callbackScope: this,
        onStart: function (i) {
          this.spheres[i].material.transparent = false;
          this.spheres[i].renderOrder = 0;
        },
        onStartParams: [i],
        onComplete: function (i) {
          this.spheres[i].visible = false;
        },
        onCompleteParams: [i]
      }, 0);
    }
  }

  // Go through label mesh and show/hide label depending on current sphere
  this.switchSphereTimeline.addCallback(this.updateLabelMeshesVisibility, fadeDuration, [], this);

  // Fade in labels meshes
  console.log(this.labelsFadeDuration);
  this.switchSphereTimeline.to(this, this.labelsFadeDuration, {labelsMeshesMainOpacity: 1, ease: easing}, fadeDuration);

  // Update camera FOV
  this.camera.fov = this.data.spheres[this.currentSphere].fov; // Reduce distortion on the sides but more zoomed. Default is 75
  this.camera.updateProjectionMatrix();

}

Panoramic.prototype.hideSphereLabels = function () {
  // Fade out labels meshes
  var easing = Linear.easeNone;
  new TweenMax.to(this, this.labelsFadeDuration, {labelsMeshesMainOpacity: 0, ease: easing});
}

Panoramic.prototype.updateLabelMeshesVisibility = function () {
  // Go through label mesh and show/hide label depending on current sphere
  for (var i = 0; i < this.labelsMeshes.length; i++) {
    var pointData = this.labelsMeshes[i].data;
    // Update label visibility
    this.labelsMeshes[i].visible = (pointData.visible_for_spheres.indexOf(this.currentSphere) !== -1);
  }
}

Panoramic.prototype.gotoSphereOnVideoEnded = function (id, fadeDuration) {
  // On video end, set a teimout to go back to first sphere
  $(this.app.videoplayer).one("videohidden", $.proxy(function () {
    console.log("Video hidden, will go to sphere", id, fadeDuration);
    this.gotoSphere(id, fadeDuration)
  }, this));
}

Panoramic.prototype.resetSphereOnVideoEnded = function (id, fadeDuration) {
  // On video end, set a teimout to go back to first sphere
  $(this.app.videoplayer).one("videohidden", $.proxy(function () {
    console.log("Video hidden, will reset to sphere", id, "in 15000ms");
    if (this.sphereResetTimeout != false) {
      clearTimeout(this.sphereResetTimeout);
      this.sphereResetTimeout = false
    }
    this.sphereResetTimeout = setTimeout($.proxy(function () {
      // Go to sphere
      console.log("Going back to sphere", id, fadeDuration);
      this.gotoSphere(id, fadeDuration);
    }, this), 15000)
  }, this));
}

Panoramic.prototype.resetSphereWithDelay = function (id, delay, fadeDuration) {
  // set a teimout to go back to first sphere
  delay = typeof delay !== "undefined" ? delay : 15;
  fadeDuration = typeof fadeDuration !== "undefined" ? fadeDuration : 1.0;

  console.log("Will reset to sphere", id, "in", delay * 1000, "seconds");
  if (this.sphereResetTimeout != false) {
    clearTimeout(this.sphereResetTimeout);
    this.sphereResetTimeout = false
  }

  this.sphereResetTimeout = setTimeout($.proxy(function () {
    // Go to sphere
    console.log("Going back to sphere", id, fadeDuration);
    this.gotoSphere(id, fadeDuration);
  }, this), delay * 1000)
}

Panoramic.prototype.enableRendering = function () {
  if (this.renderEnabled) {
    return;
  }
  this.renderEnabled = true;
  this.animate();
}

Panoramic.prototype.disableRendering = function () {
  this.renderEnabled = false;
}

Panoramic.prototype.reset = function () {
  console.log("Calling reset on Panoramic");

  $(window).off("resize", $.proxy(this.resize, this)).on("resize", $.proxy(this.resize, this));
  this.resize();

  // TODO: reset starting position etc..
  this.currentSphere = 0;
  this.labelsMeshesMainOpacity = 1;
  if (this.switchSphereTimeline) {
    this.switchSphereTimeline.kill();
  }
  if (this.sphereResetTimeout != false) {
    clearTimeout(this.sphereResetTimeout);
    this.sphereResetTimeout = false
  }
}

// Expose Panoramic
window.Panoramic = Panoramic;

